import styled from 'styled-components';

const Wrapper = styled.section`
  .products-container {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(1, 1fr);
  }

  @media (min-width: 540px) {
    .products-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 992px) {
    .products-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1200px) {
    .products-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export default Wrapper;
